
export default {
  name: "Modal",
  props: {
    hasHeader: {
      type: Boolean,
      default: false,
      required: false,
    },
    hasFooter: {
      type: Boolean,
      default: false,
      required: false,
    },
    footerHeight: {
      type: String,
      default: "5rem",
      required: false,
    },
    fullScreen: {
      type: Boolean,
      default: false,
      required: false,
    },
    width: {
      type: String,
      default: "40%",
      required: false,
    },
    height: {
      type: String,
      default: "90dvh",
      required: false,
    },
    visible: {
      type: Boolean,
      default: false,
      required: false,
    },
    showClose: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  watch: {
    visible(to) {
      if (to) {
        document.body.classList.add("no-scroll")
        this.$nextTick(() => {
          const modalBody = this.$refs.modalBody
          if (modalBody) {
            modalBody.scrollTop = 0
          }
        })
      } else {
        document.body.classList.remove("no-scroll")
      }
    },
  },
  methods: {
    closeModal() {
      document.body.classList.remove("no-scroll")
      this.$emit("closeModal")
    },
  },
}
